import { DataModel } from '../models/data.model';


export const TABLES = {
    CLIENTS: [
        new DataModel('sales_org', 'SALES_ORG', { type: 'select', options : 'sales_org' }, ''),
        new DataModel('distr_ch', 'DIST_CH',    { type: 'select', options: 'distr_ch' }, ''),
        new DataModel('country', 'COUNTRY',     { type: 'text' }, ''),
        new DataModel('main_cust_description', 'MAIN_CUSTOMER', { type: 'select', options: 'main_customer' }, ''),
        new DataModel('door_name', 'STORE',     { type: 'text' }, ''),
        new DataModel('brand_code', 'BRAND',    { type: 'text' }, ''),
        new DataModel('article_name', 'SKU',    { type: 'text' }, ''),
        new DataModel('quantity', 'QUANTITY',   { type: 'text' }, 'number'),
        new DataModel('month_of_stock', 'MONTHS_OF_STOCK', { type: 'text' }, ''),
        new DataModel('price_value', 'VALUE',   { type: 'number'} , 'price')
    ],
    USER_MANAGEMENT: [
        new DataModel('username', 'USERNAME',   { type: 'text' }, 'key'),
        new DataModel('sales_orgs', 'SALES_ORG', {}, ''),
        new DataModel('distr_chs', 'DIST_CH',    {}, ''),
        new DataModel('countries', 'COUNTRY',    {}, ''),
        new DataModel('main_cust_descriptions', 'MAIN_CUSTOMER', { }, ''),
        new DataModel('door_names', 'STORE',         { type: 'select', options: 'store', multiple: true, hide: true }, ''),
        new DataModel('user_type', 'USER_TYPE', { type: 'select', options: 'user_type', multiple: false, hide: false }, ''),
        new DataModel('email', 'EMAIL', { type: 'text' }, '' )
    ],
    STORE_MANAGEMENT: [
        new DataModel('sales_org', 'SALES_ORG', { type: 'select', options: 'sales_org', multiple: true }, 'key'),
        new DataModel('distr_ch', 'DIST_CH',    { type: 'select', options: 'distr_ch', multiple: true }, 'key'),
        new DataModel('main_cust_code', 'MAIN_CUSTOMER_CODE', { type: 'text' }, 'key'),
        new DataModel('main_cust_description', 'MAIN_CUSTOMER_DESCR', { type: 'text' }, ''),
        new DataModel('customer', 'CUSTOMER',   { type: 'text' }, ''),
        new DataModel('customer_door_code', 'CUSTOMER_DOOR_CODE', { type: 'text' }, 'key'),
        new DataModel('door_name', 'STORE', { type: 'text' }, ''),
        new DataModel('address', 'ADDRESS',     { type: 'text' }, ''),
        new DataModel('city', 'CITY',           { type: 'text' }, ''),
        new DataModel('post_code', 'POSTAL_CODE', { type: 'text' }, ''),
        new DataModel('country', 'COUNTRY',     { type: 'select', options: 'country', multiple: true }, 'key'),
        new DataModel('region', 'REGION',       { type: 'text' }, ''),
        new DataModel('main_store_door_name', 'MAIN_STORE',{  }, '')
    ],
    COMPETITORS_MANAGEMENT: [
        new DataModel('id_supplier', 'COMPETITOR_CODE', { type: 'text' }, 'key'),
        new DataModel('supplier_name', 'COMPETITOR_NAME', { type: 'text' }, ''),
        new DataModel('brand_code', 'BRAND_CODE', { type: 'text' }, 'key'),
        new DataModel('brand_name', 'BRAND_NAME', { type: 'text' }, '')
    ],
    COMPETITORS_IN_STORE: [
        new DataModel('sales_org', 'SALES_ORG',     {}, ''),
        new DataModel('distr_ch', 'DIST_CH',        {}, ''),
        new DataModel('country', 'COUNTRY',         {}, ''),
        new DataModel('main_cust_description', 'MAIN_CUSTOMER', {}, ''),
        new DataModel('door_name', 'STORE',             {}, ''),
        new DataModel('id_supplier', 'COMPETITOR_CODE', {}, ''),
        new DataModel('supplier_name', 'COMPETITOR_NAME', { }, ''),
        new DataModel('brand_code', 'BRAND_CODE',   {}, ''),
        new DataModel('brand_name', 'BRAND_NAME',   {}, '')
    ],
    COMPETITORS_SALES: [
        
        new DataModel('order_date', 'DATE',     { type: 'text'}, 'date,key'),
        new DataModel('main_cust_description', 'MAIN_CUSTOMER',        {type: 'text'}, 'key'),
        new DataModel('door_name','STORE',          {  type: 'select', options: 'store', multiple: false }, 'key'),
        new DataModel('username', 'USERNAME', {type: 'text'}, 'key'),
        new DataModel('brand_code','BRAND',             {type: 'text'}, 'key'),
        new DataModel('quantity',  'QTY', {type: 'text'}, ''),
        new DataModel('price_value', 'SELLOUT_VALUE', { type: 'price' }, 'price'),
       
    ],
    TARGET_MANAGEMENT: [
        new DataModel('sales_org', 'SALES_ORG',     {}, ''),
        new DataModel('country', 'COUNTRY',         {}, ''),
        new DataModel('main_cust_description', 'MAIN_CUSTOMER', {}, ''),
        new DataModel('customer_door_code', 'CUSTOMER_DOOR_CODE', { }, ''),
        new DataModel('door_name', 'STORE',              {  type: 'select', options: 'store', multiple: false }, 'key'),
        new DataModel('brand_code', 'BRAND',             { type: 'select', options: 'brand_ker', multiple: false }, 'key'),
        new DataModel('month_target', 'MONTH',             { type: 'date', format: 'MM/YYYY' }, 'key'),
        new DataModel('sales_target', 'SALES_TARGET', { type: 'input' } , ''),
        new DataModel('ranking_target', 'RANKING_TARGET', { type: 'text' }, '')
    ],
    BRAND_THRESHOLDS: [
        new DataModel('brand_code', 'BRAND_CODE',        { type: 'text' }, 'key'),
        new DataModel('brand_name', 'BRAND_NAME',        { type: 'text' }, 'key'),
        new DataModel('brand_limit', 'THRESHOLD',   { type: 'number' }, '')
    ]
};




export const LABLES = {
    USER_MANAGEMENT: {
        new: 'NEW_USER',
        edit: 'EDIT_USER'
    },
    STORE_MANAGEMENT: {
        new: 'NEW_STORE',
        edit: 'EDIT_STORE',
        link: 'LINK_STORE'
    },
    COMPETITORS_MANAGEMENT: {
        new: 'NEW_COMPETITOR',
        edit: 'EDIT_COMPETITOR'
    },
    COMPETITORS_IN_STORE: {
        new: 'ADD_COMPETITOR_TO_STORE',
        edit: 'EDIT_COMPETITOR_IN_STORE'
    },
    COMPETITORS_SALES: {
        new: 'ADD_COMPETITOR_SALE',
        edit: 'EDIT_COMPETITOR_SALE'
    },
    TARGET_MANAGEMENT: {
        new: 'NEW_TARGET',
        edit: 'EDIT_TARGET'
    },
    BRAND_THRESHOLDS: {
        new: 'NEW_ASSOCIATION',
        edit: 'EDIT_ASSOCIATION'
    }
};

export const ORDERBY = {
    CLIENTS: {
        default: 'door_name',
        limit: 100
    },
    USER_MANAGEMENT: {
        default: 'username'
    },
    STORE_MANAGEMENT: {
        default: 'door_name'
    },
    COMPETITORS_MANAGEMENT: {
        default: 'id_supplier'
    },
    COMPETITORS_IN_STORE: {
       default: 'door_name',
       limit: 100
    },
    COMPETITORS_SALES: {
        
     },
    
    TARGET_MANAGEMENT: {
        default: 'door_name'
    },
    BRAND_THRESHOLDS: {
        default: 'brand_name'
    }
}

